
import { Container, FederatedPointerEvent, IDestroyOptions, Rectangle, Sprite, Text, TextStyle } from "pixi.js";
import { CommonResourcesPackage } from "../../../common/resources/CommonResourcesPackage";
import { ButtonWithScaleAnimation } from "../../../common/components/ButtonWithScaleAnimation";
import { GameFont } from "../../../common/GameFont";
import { Event } from "event-system";
import gsap from "gsap";
import { UpgradeResourcePackage } from "../resources/UpgradeResourcePackage";
type Timeline = gsap.core.Timeline;

export class OutOfCoinsPanel extends Container {
    private static readonly NO_COINS_TEXT = "NOT ENOUGH GAME COINS";
    private static readonly NO_LOYALTY_COINS_TEXT = "NOT ENOUGH OWN POINTS";

    private readonly upgradeResources: UpgradeResourcePackage;
    private readonly commonResources: CommonResourcesPackage;
    private readonly perCoins: boolean;

    private bg: Sprite;
    private infoText: Text;
    private closeButton: ButtonWithScaleAnimation;
    private animationTimeline: Timeline;

    public get onCloseButtonClick(): Event<ButtonWithScaleAnimation, FederatedPointerEvent> {
        return this.closeButton.onUp;
    }

    public constructor(commonResources: CommonResourcesPackage, upgradeResources: UpgradeResourcePackage, perCoins: boolean) {
        super();
        this.commonResources = commonResources;
        this.upgradeResources = upgradeResources;
        this.perCoins = perCoins;
        this.build();
        this.layout();
        this.createAnimation();
    }

    private build(): void {
        this.bg = new Sprite(this.upgradeResources.assets_views_upgrade_upgrade_resources_out_of_coins_bg_png);
        this.addChild(this.bg);
        this.infoText = new Text(this.perCoins ? OutOfCoinsPanel.NO_COINS_TEXT : OutOfCoinsPanel.NO_LOYALTY_COINS_TEXT, new NoCoinsTextStyle());
        this.addChild(this.infoText);
        this.closeButton = new ButtonWithScaleAnimation(this.commonResources.assets_common_ui_x_png);
        this.closeButton.scale.set(0.7);
        this.closeButton.hitArea = new Rectangle(-this.closeButton.width * 0.5, -this.closeButton.height, this.closeButton.width * 2, this.closeButton.height * 2);
        this.addChild(this.closeButton);
    }

    private createAnimation(): void {
        this.animationTimeline = new gsap.core.Timeline({ paused: true });
        this.animationTimeline.fromTo(this.scale, { x: 0, y: 0 }, { x: 1, y: 1, duration: 0.4, ease: "back.out(1.5)" });
    }

    public async show(): Promise<void> {
        await this.animationTimeline.play();
    }

    public async hide(): Promise<void> {
        this.closeButton.eventMode = "none";
        await this.animationTimeline.reverse();
    }

    private layout(): void {
        this.infoText.position.set(this.width * 0.5 - this.infoText.width * 0.5, 175);
        this.closeButton.position.set(550, 35);
    }

    public override destroy(options?: boolean | IDestroyOptions): void {
        this.animationTimeline?.kill();
        this.closeButton.onUp.remove(this.hide, this);
        super.destroy(options);
    }
}

class NoCoinsTextStyle extends TextStyle {
    public constructor() {
        super(new TextStyle({
            align: "center",
            fill: "#ffffff",
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 64,
        }));
    }
}

class MoreCoinsTextStyle extends TextStyle {
    public constructor() {
        super(new TextStyle({
            align: "center",
            fill: "#ffffff",
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 41,
        }));
    }
}
